import { Type } from "class-transformer";
import { UserOutDTO } from "./user.out";

export class UserPaginatedOutDTO {
  @Type(() => UserOutDTO)
  users!: UserOutDTO[];

  total!: number;
}
